import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function ContentContainerBodyShift(props) {
  const { children, className, ...rest} = props;

  return (
    <div
      className={cx("rec-content-container", className)}
      {...rest}>
        <div className="rec-content-container-body-shift">
          {children}
        </div>
    </div>
  );
}

ContentContainerBodyShift.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};